import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
const RegistroDetalle = ({ Isadmin, tabla, close, id }) => {
  // const history = useNavigate();

  const inicial = {
  familia:"",
  edad:"",
  id_detalles:null,
  id_persona:id,
  trabajaActualmente:false
  };
 
  const [datos, setDatos] = useState(inicial);
  
  // const compare = (a, b) => {
  //   return a === b;
  // };
  useEffect(() => {
    const tablaF = async () => {
      const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/perfil.php?id=${id}`);
      const data = await res.json();
      inicial.trabajaActualmente = data[0].trabajaActualmente
      inicial.id_detalles = data[0].id_detalles
      setDatos({...datos,...data[0]})

    
    };
    tablaF();
    document.title = ` Perfil | ${process.env.REACT_APP_TITLE}`;
    
    // eslint-disable-next-line
  }, []);
console.log(datos)
  const [vali, setVali] = useState(false);
  var forms = document.querySelectorAll(".needs-validation");
  const cambio = (e) => {
    Array.prototype.slice.call(forms).forEach(function (form) {
      if (!form.checkValidity()) {
        e.preventDefault();
        e.stopPropagation();
        form.classList.add("was-validated");
        setVali(false);
      } else {
        setVali(true);
      }
    });
    const { name, value } = e.target;
    // console.log({[name]: value })
    setDatos({ ...datos, [name]: value });
  };
  const env = async (e) => {
    e.preventDefault();

    if (vali) {
      const res = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/perfil.php`,
        {
          method:  "POST",
          body: JSON.stringify(datos),
        }
      );
      const data = await res.json();

      
      if (data.resp > 0) {
        Swal.fire("Update!", "Your User has been Update.", "success");
        tabla()
        close()
      } else {
        var html = document.documentElement;
        html.scrollTop = 10;
        let alerta = document.querySelector(".alert-danger");
        alerta.classList.remove("d-none");
        alerta.innerHTML = `error interno, Revise su informacion y vuelva a intentarlo `;
      }
    } else {
      Array.prototype.slice.call(forms).forEach(function (form) {
        if (!form.checkValidity()) {
          e.preventDefault();
          e.stopPropagation();
          form.classList.add("was-validated");
        }
      });
    }
  };

  return (
    <>
      <div className="container">
        <div className=" d-flex justify-content-center alert alert-danger d-none mt-4">
          -
        </div>
        <div className="row g-5 justify-content-center">
          <div className="py-5 text-center">
            <h2> {"Detalles"} </h2>
          </div>

          <div className="col-xs-12 col-md-12 col-lg-8 ">
            <form
              onSubmit={env}
              className="needs-validation"
              noValidate
              method="post"
            >
              <div className="row g-3">
                <div className="col-sm-4">
                  <label htmlFor="firstName" className="form-label">
                  Familia
                  </label>
                  <input
                    type="text"
                    value={datos.familia}
                    onChange={cambio}
                    className="form-control"
                    id="firstName"
                    name="familia"
                    required
                  />
                  <div className="invalid-feedback">Familia es requerido.</div>
                </div>
                <div className="col-sm-4">
                  <label htmlFor="lastName" className="form-label">
              
  Edad
                  </label>
                  <input
                    type="number"
                    value={datos.edad}
                    onChange={cambio}
                    className="form-control"
                    id="lastName"
                    name="edad"
                    required
                  />
                  <div className="invalid-feedback">
                    Edad es requerido .
                  </div>
                </div>
                <div className="col-sm-4">
                  <label htmlFor="cedula" className="form-label">

  TrabajaActualmente ?
                  </label>
                  
      
      <select
                    onChange={cambio}
                    className="form-select"
                    name="trabajaActualmente"
                    id="lider"
                    required
                  >
                    
                  
                        <option value={true}>
                         si
                        </option>
                        <option value={false}>
                         No
                        </option>
                     
                  </select>
</div>
            
                  <div className="invalid-feedback cedula">
                    Campo requerido es requerida
              
                </div>
               
               
                
              </div>

              <button className="w-100 btn btn-dark btn-lg mt-5" type="submit">
                { "Agregar detalle"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default RegistroDetalle;
